import { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";

import ConfigData from "../../utils/config";
import { ShareConfig } from "./shareConfig";
import { OptionsConfig } from "./optionsConfig";
import { ReviewPointsConfig } from "./reviewPointsConfig";
import { Loading } from "../../components/Loading";

const Config = () => {
    const [shareMessages, setShareMessages] = useState(["", ""]);
    const [options, setOptions] = useState({});
    const [reviewPoints, setReviewPoints] = useState(0);
    const [loading, setLoading] = useState(true);
    const [configId, setConfigId] = useState("");
    const cfg = useRef(new ConfigData()).current;
    useEffect(() => {
        const loadConfigData = async () => {
            await cfg.loadConfig();
            const { options, shareMessage, reviewPoints, id } = await cfg.getConfig();
            setOptions(options);
            setShareMessages(shareMessage);
            setReviewPoints(reviewPoints);
            setConfigId(id);
            setLoading(false);
        };

        loadConfigData();
    }, [cfg]);

    return !loading ? (
        <Box sx={{ p: 4 }}>
            <OptionsConfig
                options={options}
                setOptions={(options) => {
                    setOptions(options);
                    const mapped = Object.entries(options).map(([key, value]) => ({
                        label: key,
                        icon: value.replace(/^"|"$/g, ""),
                    }));

                    cfg.updateConfig(configId, { options: mapped });
                }}
            />
            <ShareConfig
                shareMessage={shareMessages}
                setShareMessage={(messages) => {
                    setShareMessages(messages);
                    cfg.updateConfig(configId, {
                        share: { SHARE_TEXT_1: messages[0], SHARE_TEXT_2: messages[1] },
                    });
                }}
            />
            <ReviewPointsConfig
                reviewPoints={reviewPoints}
                setReviewPoints={(points) => {
                    setReviewPoints(points);
                    cfg.updateConfig(configId, {
                        review_points: points,
                    });
                }}
            />
        </Box>
    ) : (
        <Loading />
    );
};

export default Config;
